import { SearchspringFetcher } from '../classes/searchspring-fetcher'
import { normaliseRecommendations } from '../helpers/normalisers'
import { generateSearchspringProvider } from './provider'

export class SearchspringCustomProducts extends SearchspringFetcher {
  generateHeaders() {
    return new Headers({
      Accept: 'application/json'
    })
  }

  generateURL() {
    const endpoint = `/boost/${this.params.siteID}/recommend`
    return super.generateURL(endpoint)
  }

  updateParams(options = {}) {
    const { sku, skus, tags, limit, profile } = options

    if (sku) this.params.set('products', sku)
    if (tags) this.params.set('tags', tags)
    if (limit) this.params.set('limits', limit)
    if (profile) this.params.set('tags', profile)

    // Set the list of products to display (with variant SKUs)
    if (skus) this.params.set('lastViewed', skus.join(','))

    this.params.setCartItems()
    this.params.setShopperID()

    super.updateParams()
  }
}

export const SearchspringCustomProductsProvider = generateSearchspringProvider(
  SearchspringCustomProducts,
  (_results) => {
    const results = _results.map((res) => normaliseRecommendations(res)).flat()
    return {
      results
    }
  }
)
